/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ReferralRouteImport } from './routes/referral'
import { Route as Char42RouteImport } from './routes/*'
import { Route as IndexRouteImport } from './routes/index'
import { Route as QuestQuestIdRouteImport } from './routes/quest/$questId'

const ReferralRoute = ReferralRouteImport.update({
  id: '/referral',
  path: '/referral',
  getParentRoute: () => rootRouteImport,
} as any)
const Char42Route = Char42RouteImport.update({
  id: '/*',
  path: '/*',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const QuestQuestIdRoute = QuestQuestIdRouteImport.update({
  id: '/quest/$questId',
  path: '/quest/$questId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/*': typeof Char42Route
  '/referral': typeof ReferralRoute
  '/quest/$questId': typeof QuestQuestIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/*': typeof Char42Route
  '/referral': typeof ReferralRoute
  '/quest/$questId': typeof QuestQuestIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/*': typeof Char42Route
  '/referral': typeof ReferralRoute
  '/quest/$questId': typeof QuestQuestIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/*' | '/referral' | '/quest/$questId'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/*' | '/referral' | '/quest/$questId'
  id: '__root__' | '/' | '/*' | '/referral' | '/quest/$questId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  Char42Route: typeof Char42Route
  ReferralRoute: typeof ReferralRoute
  QuestQuestIdRoute: typeof QuestQuestIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/referral': {
      id: '/referral'
      path: '/referral'
      fullPath: '/referral'
      preLoaderRoute: typeof ReferralRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/*': {
      id: '/*'
      path: '/*'
      fullPath: '/*'
      preLoaderRoute: typeof Char42RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quest/$questId': {
      id: '/quest/$questId'
      path: '/quest/$questId'
      fullPath: '/quest/$questId'
      preLoaderRoute: typeof QuestQuestIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  Char42Route: Char42Route,
  ReferralRoute: ReferralRoute,
  QuestQuestIdRoute: QuestQuestIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
